import { useCallback, useEffect, useRef } from 'react'

const DEFAULT_CLOSE_DELAY_MS = 160

/** Defers closing a combobox panel so mousedown on a list option can commit first. */
export function useComboboxPanelClose(onClose: () => void, delayMs = DEFAULT_CLOSE_DELAY_MS) {
  const blurTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clearBlurTimer = useCallback(() => {
    if (blurTimeoutRef.current !== null) {
      clearTimeout(blurTimeoutRef.current)
      blurTimeoutRef.current = null
    }
  }, [])

  useEffect(() => () => clearBlurTimer(), [clearBlurTimer])

  const closePanelSoon = useCallback(() => {
    clearBlurTimer()
    blurTimeoutRef.current = setTimeout(onClose, delayMs)
  }, [clearBlurTimer, delayMs, onClose])

  return { clearBlurTimer, closePanelSoon }
}
